import { serviceClient, utils } from '@yola/ws-sdk';

const POLLING_INTERVAL = 3000;

const initiatePageReplacement = async ({
  pageId,
  locale,
  recipeId,
  enforceTextRegeneration = false,
}) => {
  const client = serviceClient.get();
  const response = await client.initiatePageReplacement({
    pageId,
    locale,
    recipeId,
    enforceTextRegeneration,
  });
  const {
    data: { id: jobId },
  } = response;

  return utils.pollAsyncJob({ jobId, interval: POLLING_INTERVAL });
};

export default initiatePageReplacement;
